// PostgREST silently caps a response at the project's max-rows (1000 by default) -- no error, the
// rest of the rows just never arrive. Any "load the whole table" query must page explicitly.
// `build` receives an inclusive [from, to] range and must return the query with a STABLE order
// (include a unique tiebreaker such as id), or rows can repeat/skip across pages.
export async function fetchAllRows<T>(
  build: (from: number, to: number) => PromiseLike<{ data: T[] | null; error: { message: string } | null }>,
  pageSize = 1000,
): Promise<T[]> {
  const all: T[] = []
  for (let from = 0; ; from += pageSize) {
    const { data, error } = await build(from, from + pageSize - 1)
    if (error) throw new Error(error.message)
    const rows = data ?? []
    all.push(...rows)
    if (rows.length < pageSize) return all
  }
}
